import http from "../../http";

export default {
  norepeart: {
    page: (params) => {
      return http.get("formbuilder/cluedistinctsetting/page", params);
    },
    save: (params) => {
      return http.post("formbuilder/cluedistinctsetting/save", params);
    },
    enabled: (params) => {
      return http.post("formbuilder/cluedistinctsetting/enabled", params);
    },
    del: (params) => {
      return http.post("formbuilder/cluedistinctsetting/delete", params);
    },
  },
  clue: {
    toCrmSetSave: (params) => {
      return http.post("formbuilder/tocrmcustomesetting/save", params);
    },
    toCrmSetDel: (params) => {
      return http.post("formbuilder/tocrmcustomesetting/delete", params);
    },
    toCrmSetList: (params) => {
      return http.get("formbuilder/tocrmcustomesetting/page", params);
    },
    toCrmSync: (params) => {
      return http.post("formbuilder/tocrmcustomesetting/enabled", params);
    },
  },
  // 渠道（formbuilder 端点，非 marketcenter/urlChannel）
  channel: {
    page: (params) => {
      return http.post("formbuilder/formbuild/channel/page", params);
    },
    save: (params) => {
      return http.post("formbuilder/formbuild/channel/save", params);
    },
  },
  // 渠道树（marketcenter/urlChannel/list/relateion/channelTemplate）
  channelTree: (params) => {
    return http.post("marketcenter/urlChannel/list/relateion/channelTemplate", params);
  },
  getpage: (params) => {
    return http.get("formbuilder/tocrmorg/page", params);
  },
  getorgid: (params) => {
    return http.get("formbuilder/tocrmorg/getbyorgid", params);
  },
  orgsave: (params) => {
    return http.post("formbuilder/tocrmorg/save", params);
  },
  orgdel: (params) => {
    return http.post("formbuilder/tocrmorg/delete", params);
  },

  // cc组织设置
  cc: {
    getpage: (params) => {
      return http.get("formbuilder/toccorg/page", params);
    },
    getorgid: (params) => {
      return http.get("formbuilder/toccorg/getbyorgid", params);
    },
    orgsave: (params) => {
      return http.post("formbuilder/toccorg/save", params);
    },
    orgdel: (params) => {
      return http.post("formbuilder/toccorg/delete", params);
    },
  },
  // 按字段合并导出
  mergeExport: (params) => {
    return http.post("formbuilder/applyform/merge/export", params);
  },
  syncBtn: (params) => {
    return http.get("formbuilder/tocrm/hand?sid=" + params);
  },
  //勾选线索同步至urm
  urmchecked: (params) => {
    return http.get("formbuilder/tocrm/setting?state=" + params);
  },
  //点击同步规则tab页
  syncTabs: (params) => {
    return http.get("formbuilder/tocrm/get/setting", params);
  },
  // 保存或者更新分派规则
  saveApplyFormRule: (params) => {
    return http.post("formbuilder/applyformrule/save", params);
  },
  // orgTree (opservice/org/tree/all — different from enterprise.getOrgs which uses opservice/org/tree)
  orgTree: (params) => {
    return http.post("opservice/org/tree/all", params);
  },
  // 获取分派规则列表
  getRuleList: (params) => {
    return http.post("formbuilder/applyformrule/page", params);
  },
  // 删除表单
  deleteRule: (params) => {
    return http.post("formbuilder/applyformrule/remove?id=" + params);
  },
  // 获取线索列表
  getSubmitClueList: (params) => {
    return http.post("formbuilder/applyFormSubmit/page", params);
  },
  // 手动分派
  handAssign: (params) => {
    return http.post("formbuilder/applyFormSubmit/approtion", params);
  },
  // 收回分派
  recoverAssign: (params) => {
    return http.post("formbuilder/applyFormSubmit/recover?id=" + params);
  },
  // 线索详情
  getClueDetail: (params) => {
    return http.post("formbuilder/applyFormSubmit/get?id=" + params);
  },
  // 线索详情带有邮件发送记录
  getClueDetailWithEmailLog: (params) => {
    return http.post(
      "formbuilder/applyFormSubmit/get/withemaillog?id=" + params
    );
  },
  // 管理员填写提交
  submitClueInfo: (params) => {
    return http.post("formbuilder/applyFormSubmit/manager/save", params);
  },
  // 导出表单数据
  exportForm: (params) => {
    return http.post("formbuilder/applyFormSubmit/export?formId=" + params);
  },
  getSendSetting: (params) => {
    return http.get("formbuilder/applyformrule/get/notice/setting", params);
  },
  sendSetting: (params) => {
    return http.get(
      "formbuilder/applyformrule/notice/setting?issend=" + params
    );
  },
  // 线索发送
  sendEmail: (params) => {
    return http.post("formbuilder/applyFormSubmit/send/salesman", params);
  },
  // 导出我的线索
  exportAll: (params) => {
    return http.post("formbuilder/applyFormSubmit/export/page", params);
  },
  getFilePath: (params) => {
    return http.get("formbuilder/upload/html/page/get", params);
  },
};
